<div id="popupObsidiam" class="modal fade" role="dialog" [ngClass]="themeColor === true? 'lightModal':'darkModal'">
  <div class="modal-dialog">
    <div class="boxs modal-content" style="width: 85%;z-index: 999999;">
      <div id="noUserModal" *ngIf="userList && !userList.length" class="opacity_box">
        <div class="noUserInformation">
          <img src="https://cdn-dev.obsidiam.com/img/obsidiam_artwork11.svg" alt="" class="mb-3">
          <p class="textNoUser">{{'quick_transfer.nouserMessage'|translate}}</p>
          <button class="btnObsiPay addaddress textcolor"
            (click)="showMessage()">{{'quick_transfer.add_user' | translate}}</button>
        </div>
      </div>
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <div class="box_fom boxs">
            <div class="form_bx noshadow  whiteback hd_wht  boxs">

              <div style="margin-bottom: 50px;" *ngIf="currentSendCurrency">
                <label class="float-right colorText">{{'quick_transfer.daily_limit'|translate}}:
                  <span class="number" *ngIf="sendCoinAsset"> <b
                      style="font-weight: bold;">{{feeLimitData.dailyLimitLeft * currentSendCurrency.value |number:'1.0-2'}}</b>
                  </span>
                  <span class="number" *ngIf="!sendCoinAsset"> <b
                      style="font-weight: bold;">{{feeLimitData.dailyLimitLeft / currentSendCurrency.price |number:'1.0-8' }}</b>
                  </span>
                  <b style="margin-left: 3px;">{{currentSendCurrency.shortName}}</b>
                </label>
              </div>

              <div class="text-center makeObsiTitle">
                <h5 class="textcolor makeObsiTitleText">{{'quick_transfer.make_quick' | translate}}</h5>
                <img id="obsiImg2" height="25"
                  src="{{themeColor=== true?(imgUrl + 'img/obsidiam_obsipay_black_logo.png'):(imgUrl + 'img/obsidiam_obsipay_white_logo.png')}}"
                  style="margin-left: 10px; margin-bottom: 6px;">
              </div>

              <form>

                <div class="formstyle boxs">
                  <div class="form-group whit_b whit_bb1">
                    <label class="textcolor">{{'quick_transfer.quick_recipient' | translate}}
                    </label>
                    <input (click)="getUsers($event)" readonly type="text" id="coin2"
                      class="form-control textcolor req_sec coin_inptt enter_usddd1 cursorPointer" autocomplete="none"
                      placeholder="{{'quick_transfer.select_user' | translate}}" required>
                    <span><i (click)="getUsers($event)" id="coin2Img"
                        [ngClass]="autoSearchuserList && autoSearchuserList.length?'fa-angle-up':'fa-angle-down'"
                        class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"></i></span>
                    <div class="drop_down drop_down1" *ngIf="autoSearchuserList && autoSearchuserList.length">

                      <ul class="drop_menu boxs">
                        <li *ngFor="let usr of autoSearchuserList;">
                          <a href="javascript:;" (click)="selectUserForSendCoin(usr)" class="active textcolor">
                            <i class="bit_para">{{usr.username}}</i><span>{{usr.label}}</span></a>
                        </li>
                        <li><a href="javascript:;" (click)="showMessage()"
                            class="textcolor">{{'quick_transfer.add_user'|translate}}</a>
                        </li>

                      </ul>
                    </div>

                    <label class="error" *ngIf="errors.sendUserId">{{errors.sendUserId|translate}}</label>

                  </div>
                </div>

                <div class="formstyle boxs">
                  <div class="form-group whit_b whit_bb1">
                    <label class="textcolor">{{'quick_transfer.coin' | translate}}</label>
                    <input readonly (click)="searchCurrency($event)" type="text" id="sendcoin2" autocomplete="none"
                      class="form-control textcolor req_sec coin_inptt enter_usddd1 cursorPointer"
                      placeholder="{{'quick_transfer.select_coin' | translate}}" required>
                    <span><i (click)="searchCurrency($event)" id="sendcoin2Img"
                        [ngClass]="currencies && currencies.length?'fa-angle-up':'fa-angle-down'"
                        class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"></i></span>
                    <div class="drop_down drop_down1" style="top: 70px; left: 0;"
                      *ngIf="currencies && currencies.length">

                      <ul class="drop_menu boxs">

                        <li *ngFor="let coin of currencies;">
                          <a *ngIf='coin.obsipay' href="javascript:void(0)" (click)="selectCoinForSendCoin(coin)"
                            class="active textcolor">
                            <i
                              class="bit_para">{{coin.fullName}}</i><span>{{coin.availableBalance |number:'1.0-8'}}{{' '+coin.shortName}}</span></a>
                        </li>

                      </ul>
                    </div>
                    <label class="error" *ngIf="errors.sendCoinId">{{errors.sendCoinId|translate}}</label>

                  </div>
                </div>

                <div class="formstyle boxs">
                  <div class="form-group whit_b whit_bb1" [ngClass]="sendCoinDatacoinType">
                    <label class="textcolor">{{'quick_transfer.amount' | translate}}</label>
                    <div id="boxAmount2">
                      <div class="row no-pad box-amount" style="width: 100%;margin-bottom: 10px;">
                        <div class="col-sm-9 col-md-9 col-lg-10 amount-box1">
                          <div id="coinSymbol">
                            <div class="coin-symbol textcolor" *ngIf="currentSendCurrency && sendCoinAsset"
                              [style.width.px]="currentSendCurrency.shortName === 'ARS' || currentSendCurrency.shortName === 'CLP' || currentSendCurrency.shortName === 'COP'? '80': '0'">
                              {{currentSendCurrency.symbol}}</div>
                          </div>
                          <div>
                            <img id="coinIcon" class="coin-icon" *ngIf="currentSendCurrency && !sendCoinAsset"
                              [src]="currentSendCurrency.imageUrl">
                          </div>
                          <div>
                            <input class="number" #amount (keydown)="restrictNumberLength($event, amount.value)"
                              onkeypress='return (event.charCode>=48 && event.charCode<=57) || event.charCode==0 || event.charCode==46'
                              (input)="calculateEstimateValue(); controlInputAmount()" name="amount" id="amount2"
                              type="text" max="8" class="amount-transfer form-control textcolor req_sec"
                              placeholder="0.00" required autocomplete="none" (paste)="onPaste($event)">
                          </div>
                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-2 box-amount" style="display: flex;">
                          <div *ngIf="currentPreferredCurrency && currentSendCurrency" class="coin-select"
                            [style.margin-left.px]="currentSendCurrency.shortName === 'ARS' || currentSendCurrency.shortName === 'CLP' || currentSendCurrency.shortName === 'COP'? '80': '0'">
                            <div class="send-coin" *ngIf="!sendCoinAsset">{{currentSendCurrency.shortName }}</div>
                            <div class=" send-coin" *ngIf="sendCoinAsset">
                              <div class="form-group whit_b whit_bb1"
                                style="padding: 0 0 0 0;float: left; display:flex; align-items: center; margin-right: -5px; margin-bottom: 0;">
                                <div (click)="searchLocalCurrency($event)">
                                  <input readonly type="text" id="localCoin" autocomplete="none"
                                    class="currency-select textcolor req_sec coin_inptt enter_usddd1 cursorPointer"
                                    style="border: none; padding: 0;" [placeholder]="currentSendCurrency.shortName">
                                  <span><i id="downImg"
                                      [ngClass]="localCurrencies && localCurrencies.length?'fa-angle-up':'fa-angle-down'"
                                      class="fa  fa_dwn textcolor cursorPointer" aria-hidden="true"
                                      style="top: 10px; margin-right: -15px"></i></span>
                                </div>
                                <div class="drop_down currency_list" (focusout)="localCurrencies = []"
                                  style="top: 50px; left: 0; min-width: 30px;max-height: 150px; overflow-y: auto;"
                                  *ngIf="localCurrencies && localCurrencies.length">

                                  <ul class="drop_menu boxs">

                                    <li *ngFor="let coin of localCurrencies;">
                                      <a *ngIf='selectedCoin.shortName != coin.shortName' href="javascript:void(0)"
                                        (click)="selectCurrencyForSendCoin(coin)" class="active textcolor">
                                        <i class="bit_para">{{coin.fullName}}</i><span>{{coin.shortName}}</span></a>
                                    </li>

                                  </ul>
                                </div>

                              </div>
                            </div>
                            <div *ngIf="selectedCoin.shortName !== undefined" class="line-currencies"></div>

                            <div style="margin-left: 5px; height: 20px; font-size: 16px"
                              *ngIf="selectedCoin.shortName !== undefined" class="textcolor"
                              (click)="changeSendCoinType(currentSendCurrency, currentPreferredCurrency); localCurrencies = []">
                              {{currentPreferredCurrency.shortName}}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>

                <div class="formstyle boxs">
                  <div class="form-group whit_b whit_bb1">
                    <label class="error" *ngIf="errors.sendAmount">{{errors.sendAmount|translate}}</label>
                    <label class="error" *ngIf="feeLimitErrorMaxAmount">
                      {{feeLimitErrorMaxAmount}}
                    </label>
                    <label class="error" *ngIf="errors.sendAmountMin">
                      {{errors.sendAmountMin}}
                      <span class="number textcolor" *ngIf="sendCoinAsset"> <b
                          style="font-weight: bold;">{{this.feeLimitErrorAmount * this.currentSendCurrency.value |number:'1.0-2'}}</b>
                      </span>

                      <span class="number textcolor" *ngIf="!sendCoinAsset"> <b
                          style="font-weight: bold;">{{this.feeLimitErrorAmount / this.currentSendCurrency.price  |number:'1.0-8' }}</b>
                      </span>
                      <b style="margin-left: 3px;">{{currentSendCurrency.shortName}}</b>
                    </label>
                    <label style="text-align: left;width: 100%;"
                      class="textcolor">{{'quick_transfer.available' | translate}}

                      <strong><span
                          class="number textcolor">{{(selectedCoin.availableBalance||0)|number:'1.0-8'}}</span>
                        {{selectedCoin.shortName}}</strong> </label>
                    <label *ngIf="selectedCoin.shortName !== undefined" style="text-align: left;width: 100%;"
                      class="textcolor">{{'wallet.estimated' | translate}}
                      <strong>
                        <span class="number textcolor">{{estimateValue}}</span>
                        {{currentPreferredCurrency.shortName||'USD'}}
                      </strong>
                    </label>
                  </div>
                </div>

                <div class="boxs conf_btn code_div">
                  <ul class="yes_lu2">

                    <li>
                      <a href="javascript:;" id="sendCoinBtn" (click)="sendCoin()"
                        class="sign_yes no_btn">{{'quick_transfer.send' | translate}}</a>
                    </li>
                  </ul>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- NO VERIFIED USER -->
<div id="quick" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content boxs">
      <div class="modal-body boxs">
        <div class="qrcode_scan amount_div boxs">
          <img src="{{imgUrl + 'img/obsidiam_info_icon.svg'}}" class="img-responsive" alt="qr_code">
          <h5>{{'quick_transfer.get_verify' | translate}}</h5>
          <p>{{'quick_transfer.platform' | translate}}</p>
          <div class="boxs conf_btn">
            <ul class="yes_lu">
              <li><a href="javascript:;" data-dismiss="modal"
                  class="back_btn no_btn">{{'quick_transfer.not_now' | translate}}</a></li>
              <li><a href="javascript:;" (click)="routerToVerification()"
                  class="sign_yes no_btn">{{'quick_transfer.get_verified' | translate}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>